//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import api from "../../../api";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';


export const loginUser = (user, history) => async (dispatch) => {
  try {
    const response = await api.post("Auth/login", user);
    console.log("Whats the Data: ", response.data);

    if (response.status === 200) {
      sessionStorage.setItem("authUser", JSON.stringify(response.data));
      // Cross-tab persistence: mirror auth into localStorage so a NEW tab can
      // inherit this login (see helpers/sessionPersist.js, which restores it).
      try { localStorage.setItem("persist:authUser", JSON.stringify(response.data)); } catch (e) { /* ignore */ }

      // Phase 3 (Legacy Access Parity): AuthController returns the full
      // EffectiveAccessBundle in response.data.access. Cache it under
      // sessionStorage["permissions"] (kept that key name so older code
      // expecting a permissions cache continues to find SOMETHING). The
      // useAuth() hook now reads the FULL bundle from here, not just
      // the permission array.
      //
      // Backwards-compat: older builds wrote just response.data.permissions
      // (a string array). If `access` isn't present, fall back to that.
      const access = response.data?.access ?? null;
      if (access && typeof access === "object") {
        sessionStorage.setItem("permissions", JSON.stringify(access));
        try { localStorage.setItem("persist:permissions", JSON.stringify(access)); } catch (e) { /* ignore */ }
      } else if (Array.isArray(response.data?.permissions)) {
        sessionStorage.setItem(
          "permissions",
          JSON.stringify(response.data.permissions)
        );
        try { localStorage.setItem("persist:permissions", JSON.stringify(response.data.permissions)); } catch (e) { /* ignore */ }
      } else {
        sessionStorage.removeItem("permissions");
        try { localStorage.removeItem("persist:permissions"); } catch (e) { /* ignore */ }
      }

      dispatch(loginSuccess(response.data));

      // redirect check
      const params = new URLSearchParams(window.location.search);
      const redirectTo = params.get("redirect");
      if (redirectTo) {
        history(decodeURIComponent(redirectTo));
      } else {
        history("/dashboard");
      }
    } else {
      dispatch(apiError("Invalid credentials."));
    }
  } catch (error) {
    let msg = "Login failed!";
    if (error.response?.data) {
      const errData = error.response.data;

      // Case 1: validation error (model state)
      if (errData.errors) {
        const messages = Object.values(errData.errors).flat();
        msg = messages.join(" ");
      }

      // Case 2: normal string error
      else if (typeof errData === "string") {
        msg = errData;
      }

      // Optional fallback
      else if (errData.title) {
        msg = errData.title;
      }
    }

    console.log("Error is here:", msg);
    dispatch(apiError(msg));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    // Cross-tab logout: clear the localStorage mirror FIRST so other tabs see
    // the storage event and drop their session too (see sessionPersist.js).
    try {
      localStorage.removeItem("persist:authUser");
      localStorage.removeItem("persist:permissions");
    } catch (e) { /* ignore */ }
    sessionStorage.removeItem("authUser");
    sessionStorage.clear();
    let fireBaseBackend = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};